<template>
  <v-card
    :width="width"
    class="overflow-hidden card-media"
  >
    <v-img v-if="media.type === $constants.AMB_MEDIA_TYPES.VIDEO && media.preview_url"
           class="d-block"
           width="100%"
           :src="media.preview_url"
    >
    </v-img>
    <v-img v-else-if="media.type === $constants.AMB_MEDIA_TYPES.IMAGE && media.url"
        class="d-block"
        width="100%"
        :src="media.url"
    >
    </v-img>
    <v-container v-else class="converting-status grey lighten-2">
      <v-row
        class="fill-height"
        align-content="center"
        justify="center"
      >
        <v-col class="text-center" cols="12">
          Converting media: {{ media.id }}
        </v-col>
        <v-col cols="6">
          <div
            v-if="media.status === $constants.AMB_MEDIA_STATUSES.ERROR"
            class="text-center red--text"
          >
            Error
          </div>
          <v-progress-linear
            v-else
            indeterminate
            rounded
          ></v-progress-linear>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
      v-if="media.url"
      v-model="showPlayDialog"
      width="initial"
      eager
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="play-button"
          fab x-small
          v-bind="attrs"
          v-on="on"
          @click="init = true"
        >
          <v-icon v-if="media.type === $constants.AMB_MEDIA_TYPES.VIDEO">mdi-play</v-icon>
          <v-icon v-else>mdi-magnify-plus</v-icon>
        </v-btn>
      </template>
      <v-card>
        <div v-if="media.type === $constants.AMB_MEDIA_TYPES.VIDEO && init">
          <video
              class="d-block"
              style="height:70vh"
              controls
              autoplay
              playsinline
              loop
              muted
              :src='media.url'
              @loadeddata="loadedDialogVideo"
              ref="videoInDialog"
          />
        </div>
        <div v-else-if="init" class="image_popup">
          <div class="image_scroll">
            <v-img
                :src="media.url"
            >
            </v-img>
          </div>
          <v-btn
              class="download-button"
              fab x-small
              @click="downloadMedia"
          >
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </div>
        <v-btn
            class="close-button"
            fab x-small
            @click="showPlayDialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="rejectDialog.show"
      width="initial"
    >
      <v-card>
        <v-card-title>Why are you reject media?</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-textarea
                  outlined
                  v-model="rejectDialog.comment"
                  label="Comment"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="rejectDialog.show = false"
          >
            Cancel
          </v-btn>
          <v-btn
            @click="rejectMedia"
            color="blue darken-1"
            text
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="commentDialog.show"
      width="initial"
    >
      <v-card>
        <v-card-title>Comment</v-card-title>
        <v-card-text>
          <v-textarea
            outlined
            v-model="commentDialog.comment"
            label="Comment"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="commentDialog.show = false"
          >
            Cancel
          </v-btn>
          <v-btn
            @click="updateComment"
            color="blue darken-1"
            text
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="statusDialog.show"
      width="initial"
    >
      <v-card>
        <v-card-title>Status</v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="statusDialog.status"
            :items="mediaStatusesFiltered"
            item-text="name"
            item-value="id"
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="statusDialog.show = false"
          >
            Cancel
          </v-btn>
          <v-btn
            @click="changeStatusMedia(statusDialog.status)"
            color="blue darken-1"
            text
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="menu-button">
      <v-menu
          left
          origin="center center"
          transition="scale-transition"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              x-small fab
              v-bind="attrs"
              v-on="on"
          >
            <v-icon>
              mdi-dots-vertical
            </v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item>
            <v-btn
              block
              depressed
              small
              @click="
                statusDialog.status = media.status;
                statusDialog.show = true"
            >
              Change status
              <v-spacer></v-spacer>
              <v-icon small class="ml-2">
                mdi-list-status
              </v-icon>
            </v-btn>
          </v-list-item>

          <v-list-item>
            <v-btn
              :color="media.comment ? 'green' : ''"
              block
              depressed
              small
              @click="
                commentDialog.comment = media.comment;
                commentDialog.show = true"
            >
              comment
              <v-spacer></v-spacer>
              <v-icon small class="ml-2">
                mdi-comment-text-outline
              </v-icon>
            </v-btn>
          </v-list-item>

          <v-list-item v-if="hasDeleteListener && deletable">
            <v-btn block depressed small @click="deleteMedia">
              delete
              <v-spacer></v-spacer>
              <v-icon color="red" small>
                mdi-delete
              </v-icon>
            </v-btn>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <div v-if="media.duration" class="media-duration">{{ duration }}</div>

    <div
      v-if="[
        $constants.AMB_MEDIA_STATUSES.ARCHIVE, $constants.AMB_MEDIA_STATUSES.REJECTED
        ].includes(media.status)"
      class="shadow-box"
    >
    </div>

    <div
      class="purple darken-2 pa-1"
      v-if="poiStatus !== $constants.AMB_POI_STATUSES.NEW"
    >
      <div class="white--text">Status: {{ media.status_name }}</div>
      <div class="white--text" v-if="media.status !== $constants.AMB_MEDIA_STATUSES.NEW">
        Display order:
        <v-edit-dialog
          @save="updatePriority(media)"
          @open="selectedMedia = {
            id: media.id,
            priorityId: media.priority,
          }"
          large
        >
          <span class="font-weight-bold">{{
              media.priority_name ? media.priority_name : 'empty'
            }}</span>
          <template v-slot:input>
            <v-select
              :items="mediaPriorities"
              :item-text="item => `${item.name}`"
              item-value="id"
              label="display order"
              v-model="selectedMedia.priorityId"
            />
          </template>
        </v-edit-dialog>
        <v-btn
          v-if="media.type === $constants.AMB_MEDIA_TYPES.IMAGE
           && media.status === $constants.AMB_MEDIA_STATUSES.ACCEPTED
           && !media.media_data_id"
          class="px-1 mt-3 action_add_to_poi"
          x-small
          color="green"
          :disabled="media.priority === null"
          @click="addMediaToPoi()"
        >
          Add to Poi
        </v-btn>
      </div>
      <div v-else class="d-flex justify-space-around">
        <v-btn
          class="px-1 mx-1"
          x-small
          color="green"
          @click="changeStatusMedia($constants.AMB_MEDIA_STATUSES.ACCEPTED)"
        >
          Accept
        </v-btn>
        <v-btn
          class="px-1 mx-1"
          x-small
          color="yellow"
          @click="changeStatusMedia($constants.AMB_MEDIA_STATUSES.ARCHIVE)"
        >
          Archive
        </v-btn>
        <v-btn
          class="px-1 mx-1"
          x-small
          color="red"
          @click="rejectDialog.show = true">
          Reject
        </v-btn>
      </div>
    </div>

    <slot></slot>

  </v-card>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'AmbMediaCard',
  props: {
    width: {
      type: Number,
      default: 200,
    },
    media: {
      type: Object,
      default: () => {},
    },
    poiStatus: {
      type: Number,
      default: 0,
    },
    mediaPriorities: {
      type: Array,
      default: () => [],
    },
    mediaStatuses: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    showPlayDialog: false,
    init: false,

    selectedMedia: {
      id: null,
      priorityId: null,
    },
    rejectDialog: {
      show: false,
      comment: null,
    },
    commentDialog: {
      show: false,
      comment: null,
    },
    statusDialog: {
      show: false,
      status: null,
    },
  }),
  computed: {
    hasDeleteListener() {
      return this.$listeners && this.$listeners.deleteMedia;
    },
    duration() {
      let minutes = Math.floor(this.media.duration / 60);
      minutes = String(minutes).padStart(2, '0');
      let seconds = this.media.duration % 60;
      seconds = String(seconds).padStart(2, '0');
      return `${minutes}:${seconds}`;
    },
    deletable() {
      return this.poiStatus !== this.$constants.AMB_POI_STATUSES.NEW
        || this.media.status === this.$constants.AMB_MEDIA_STATUSES.ERROR;
    },
    mediaStatusesFiltered() {
      return this.mediaStatuses.filter(
        (e) => ![
          this.$constants.AMB_MEDIA_STATUSES.DONE,
          this.$constants.AMB_MEDIA_STATUSES.DOWNLOADED,
          this.$constants.AMB_MEDIA_STATUSES.IN_PROGRESS,
        ].includes(e.id),
      );
    },
  },
  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    downloadMedia() {
      let url = this.media.url.replace('?raw=1', '?dl=1');
      url = url.replace('&raw=1', '&dl=1');

      window.open(url, '_blank');
    },

    deleteMedia() {
      this.$emit('deleteMedia', this.media.id);
    },

    updatePriority() {
      this.$requestHelpers
        .patch(
          `api/admin/ambassador/media/priority/${this.selectedMedia.id}`,
          {
            priority: this.selectedMedia.priorityId,
          },
        )
        .then((response) => {
          if (response.data.success) {
            const data = response.data.result;

            this.setSnack({
              color: 'green',
              text: 'saved',
            });

            Object.assign(this.media, data);
          }
        }).finally(() => {
          this.selectedMedia.id = null;
          this.selectedMedia.priority = null;
        });
    },

    changeStatusMedia(status) {
      if (status === this.$constants.AMB_MEDIA_STATUSES.REJECTED) {
        this.rejectDialog.show = true;
        return;
      }

      this.$requestHelpers
        .patch(`api/admin/ambassador/media/update/${this.media.id}`, { status })
        .then((response) => {
          if (response.data.success) {
            Object.assign(this.media, response.data.result);
          }
          this.statusDialog.status = null;
          this.statusDialog.show = false;
        });
    },

    rejectMedia() {
      this.$requestHelpers
        .patch(`api/admin/ambassador/media/update/${this.media.id}`, {
          status: this.$constants.AMB_MEDIA_STATUSES.REJECTED,
          comment: this.rejectDialog.comment,
        })
        .then((response) => {
          if (response.data.success) {
            Object.assign(this.media, response.data.result);
          }
          this.rejectDialog.comment = null;
          this.rejectDialog.show = false;
        });
    },

    updateComment() {
      this.$requestHelpers
        .patch(`api/admin/ambassador/media/update/${this.media.id}`, {
          comment: this.commentDialog.comment,
        })
        .then((response) => {
          if (response.data.success) {
            Object.assign(this.media, response.data.result);
          }
        }).finally(() => {
          this.commentDialog.show = false;
          this.commentDialog.comment = null;
        });
    },

    addMediaToPoi() {
      if (this.media.priority === null) {
        this.setSnack({
          color: 'red',
          text: 'Empty media order',
        });
        return;
      }

      this.$confirm('Are you sure you want to add this media to poi?').then((res) => {
        if (!res) return;

        this.$requestHelpers
          .post(`api/admin/ambassador/media/add-to-poi/${this.media.id}`)
          .then((response) => {
            if (response.data.success) {
              Object.assign(this.media, response.data.result);
            }
          }).finally(() => {
            this.commentDialog.show = false;
            this.commentDialog.comment = null;
          });
      });
    },

    loadedDialogVideo() {
      if (this.$refs.videoInDialog && this.showPlayDialog) {
        this.$refs.videoInDialog.play();
      }
    },
  },
  watch: {
    showPlayDialog(newValue) {
      if (this.$refs.videoInDialog) {
        if (!newValue) {
          this.$refs.videoInDialog.pause();
        } else if (this.$refs.videoInDialog) {
          this.$refs.videoInDialog.play();
        }
      }
    },
  },
};
</script>

<style scoped>
.card-media {
  min-width: 100px;
  min-height: 100px;
}
.converting-status {
  height: 200px;
}
.play-button {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1;
}
.menu-button {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
}
.close-button {
  position: absolute;
  top: 20px;
  right: 20px;
}
.image_popup {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
}
.image_scroll {
  max-height: 90vh;
  overflow: auto;
}
.download-button {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.media-duration {
  position: relative;
  float: right;
  margin-top: -20px;
  margin-right: 5px;
  color: #ffffff;
  font-weight: bold;
}
.shadow-box {
  position: absolute;
  top: 0;
  left: 0;
  background: rgb(204 204 204 / 71%);
  bottom: 0;
  right: 0;
}
.action_add_to_poi.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: rgb(255 255 255) !important;
}
</style>
